import { render, staticRenderFns } from "./preview-message-dialog.vue?vue&type=template&id=3ffc0f9f&scoped=true&"
import script from "./preview-message-dialog.vue?vue&type=script&lang=js&"
export * from "./preview-message-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffc0f9f",
  null
  
)

export default component.exports